__turbopack_context__.v({
  "motionSlot": "DashedTrailReveal-module__3C8uKW__motionSlot",
  "reducedStatic": "DashedTrailReveal-module__3C8uKW__reducedStatic",
  "slot": "DashedTrailReveal-module__3C8uKW__slot",
});
